import { allDone } from '../../../../../img/images';
import { ILocalization } from '../../../../../localization/definitions/types';
import { InstructionTickIcon } from '../../../../shared/icons/icons';

export const AllDoneSlideImage = () => {
    return (
        <div className='carousel-img w-100 h-100'>
            <div className='all-done-slide'>
                <img alt='' src={allDone} />
            </div>
        </div>
    );
};

export const AllDoneSlideImageSrc = allDone;

interface Props {
    localization: ILocalization;
}

export const AllDoneSlideContent = ({ localization }: Props) => {
    const { allDoneSlide } =
        localization.localizationStrings.susy.thesisManagement.tutorial.user
            .slides;

    return (
        <div className='tutorial-content-wrapper'>
            <h1>{allDoneSlide.allDoneTitle}</h1>
            <h4>{allDoneSlide.nowItsSubmissionTime}​</h4>

            <div className='instruction-row'>
                <div className='instruction-tick'>
                    <InstructionTickIcon />
                    <div />
                </div>
                <div className='instruction-content'>
                    <span className='instruction-content-bold'>
                        {allDoneSlide.uploadAndSubmit}
                    </span>{' '}
                    {allDoneSlide.yourFinalProject}
                </div>
            </div>
            <div className='instruction-row'>
                <div className='instruction-tick'>
                    <InstructionTickIcon />
                    <div />
                </div>
                <div className='instruction-content'>
                    {allDoneSlide.leanBack}
                    <span className='instruction-content-bold'>
                        {allDoneSlide.gradingResults}
                    </span>
                    .
                </div>
            </div>
        </div>
    );
};
